// eslint-disable-next-line import/prefer-default-export
export var getHtmlElementFromHtmlTagProp = function getHtmlElementFromHtmlTagProp(options, htmlTag, variant) {
  var variantKey = variant;
  return htmlTag || options[variantKey];
};
var isVariantValue = function isVariantValue(value, availableVariants) {
  return availableVariants.includes(value);
};
export var isColorVariantValue = function isColorVariantValue(value, availableVariants) {
  if (isVariantValue(value, availableVariants)) {
    return {
      color: value
    };
  }
  return {
    css: {
      color: value
    }
  };
};